<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Login</v-card-title>
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.email"
                      placeholder="Digite seu Email"
                      label="Email *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.senha"
                      placeholder="Digite seu Senha"
                      label="Senha *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      type="password"
                    ></v-text-field>
                    <router-link :to="isEntidade ? '/carteira-macrorregiao/recuperar-senha-entidade' : '/carteira-macrorregiao/recuperar-senha-grafica'">
                      <a><v-icon small color="blue">call_made</v-icon>Esqueceu a senha?</a>
                    </router-link>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                    >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout> </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import AuthService from "@/services/sie-pedidos/auth.service";



export default {
  components: {
    VueRecaptcha
  },
  metaInfo: {
    title: "Carteira Macrorregião",
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    form: {
      email: "",
      senha: "",
      recaptcha: null,
    },
    dataAluno: [],
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
    },
    openDialog: "",
    alert: false,
    msg: "",
    isEntidade: AuthService.isEntidade()
  }),
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const {email, senha} = this.form;
        AuthService.login(email, senha)   
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}
</style>
